<template>
  <div
    id="microApp"
    :class="appClass"
    class="relative flex-col !overflow-hidden"
  >
    <div v-show="!hideTitle" class="head-box justify-between items-center">
      <IconBack class="left icon-back" @click.native="goBack"></IconBack>
      <div class="flex items-center">
        <!-- <img class="img" :src="getAssetImageUrl('ai_title_logo.png')" /> -->
        <span class="text" v-if="isShowTitle">{{ title }}</span>
      </div>
      <IconBack
        v-if="!fromBrowser"
        class="opacity-0 icon-back"
        @click.native="goBack"
      ></IconBack>
      <IconClose v-else class="right" @click.native="closeIframe"></IconClose>
    </div>
    <IconClose
      v-show="hideTitle && fromBrowser"
      class="right-top-btn"
      @click.native="closeIframe"
    ></IconClose>
    <iframe
      v-show="routeName === 'SubApp'"
      key="dialogueIframe"
      ref="dialogueIframe"
      class="w-full h-full flex-1"
      :src="dialogueUrl"
      @load="load()"
    ></iframe>
    <!-- <template v-if="routeName !== 'SubApp'"> -->
    <transition
      v-show="routeName !== 'SubApp'"
      mode="out-in"
      :enter-active-class="enterActiveClass"
      :leave-active-class="leaveActiveClass"
    >
      <template v-if="enablePageStack">
        <keep-alive :include="cacheNameArr">
          <router-view v-if="isRouterAlive" class="flex-1 overflow-y-hidden">
          </router-view>
        </keep-alive>
      </template>
      <template v-else>
        <router-view v-if="isRouterAlive" class="flex-1 overflow-y-hidden" />
      </template>
    </transition>
    <!-- </template> -->
  </div>
</template>

<script>
import pick from "lodash-es/pick";
import pull from "lodash-es/pull";
import cloneDeep from "lodash-es/cloneDeep";
import isString from "lodash-es/isString";
import { getAppInstance } from "@/utils/app";
import { getAssetImageUrl } from "@/utils/asset";
import { isFunction } from "lodash-es";
import { connectToParent } from "penpal";
import store from "@/store";
import { mapGetters } from "vuex";
import { PageJumpType } from "@/enum/PageJumpType";
import { DIALOGUE_URL } from "@/views/home/iframeUrl.js";
import { connectToChild } from "penpal";

export default {
  name: "MicroApp",
  provide() {
    return {
      addBeforeBackFun: this.addBeforeBackFun,
      delBeforeBackFun: this.delBeforeBackFun,
      setTitle: this.setTitle,
      getTitle: this.getTitle,
      setIsShowTitle: this.setIsShowTitle,
      getDialogueIframe: () => {
        return this.aIDialogueIframe;
      },
      getIsAIDialogueIframeLoad: ({ search = "" } = {}) => {
        this.aIDialogueSearch = search;
        return this.isAIDialogueIframeLoad;
      },
    };
  },
  data() {
    return {
      isRouterAlive: true,
      enterActiveClass: undefined,
      leaveActiveClass: undefined,
      enablePageStack: !!(
        import.meta.env.VITE_ENABLE_PAGE_STACK || import.meta.env.PROD
      ),
      hideTitle: true,
      title: null,
      beforeBackFunArr: [],
      fromBrowser: false,
      isShowTitle: true,
      dialogueUrl: DIALOGUE_URL, // AI对话
      aIDialogueIframe: null,
      aIDialogueSearch: "",
      isAIDialogueIframeLoad: false,
    };
  },
  watch: {
    reload(nv) {
      if (nv) {
        this.isRouterAlive = false;
        const keepList = cloneDeep(this.keepList);
        const oldKeepList = cloneDeep(keepList);
        const defaultName = isString(nv)
          ? nv
          : this.$route?.matched?.[0]?.components?.default?.name;
        this.$store.dispatch("setKeepList", pull(keepList, defaultName));
        this.$nextTick(() => {
          this.isRouterAlive = true;
          this.$store.dispatch("setKeepList", oldKeepList);
          this.$store.dispatch("reload", false);
        });
      }
    },
    async $route(to, from) {
      const hideTitle = to?.meta?.hideTitle;
      if (isFunction(hideTitle)) {
        this.hideTitle = await hideTitle();
      } else {
        this.hideTitle = hideTitle;
      }
      this.setTitle(to?.query?.title || to?.meta?.title || null);
      // if (import.meta.env.DEV) return;
      let classArr = ["animate__animated", "animate__faster"];
      if (to.name === "home" || from.name === "home") {
        classArr = [];
      }
      if (to.params["stack-key-dir"] === PageJumpType.forward.value) {
        this.enterActiveClass = [...classArr, "animate__fadeInRight"].join(" ");
        this.leaveActiveClass = [...classArr, "animate__fadeOutLeft"].join(" ");
      } else {
        this.enterActiveClass = [...classArr, "animate__fadeInLeft"].join(" ");
        this.leaveActiveClass = [...classArr, "animate__fadeOutRight"].join(
          " "
        );
      }
    },
  },
  async created() {
    this.connectAIDialogue();
    await this.init();
  },
  methods: {
    setTitle(title) {
      this.title = title;
    },
    setIsShowTitle(bol) {
      this.isShowTitle = bol;
    },
    getTitle() {
      return this.title;
    },
    async closeIframe() {
      const connection = connectToParent({
        methods: {
          setModel(model) {
            store.dispatch("setParentModel", model);
          },
        },
      });
      const parent = await connection.promise;
      if (parent.hideIframe && typeof parent.hideIframe === "function") {
        await parent.hideIframe();
      }
    },
    async goBack() {
      if (this.beforeBackFunArr.length) {
        for (const fun of this.beforeBackFunArr) {
          if (!isFunction(fun)) continue;
          if (await fun()) {
            return true;
          }
        }
      }
      if (this.cacheViewArr.length > 1) {
        this.$router.back();
        return true;
      }
      return false;
    },
    addBeforeBackFun(fun) {
      if (!isFunction(fun)) throw new Error("参数必须为函数");
      this.beforeBackFunArr.unshift(fun);
    },
    delBeforeBackFun(fun) {
      if (!isFunction(fun)) throw new Error("参数必须为函数");
      const index = this.beforeBackFunArr.findIndex((item) => item === fun);
      if (index >= 0) {
        this.beforeBackFunArr.splice(index, 1);
      }
    },
    getAssetImageUrl,
    initApp() {
      const tyApp = getAppInstance();
      if (!tyApp) return;
      window.goBack = this.goBack;
    },
    async init() {
      const query = pick(this.$route.query, ["fromBrowser"]);
      if (query.fromBrowser) {
        this.fromBrowser = query.fromBrowser;
      }
      this.initApp();
      await Promise.all([
        // 获取稿件类别列表和获取稿件类型列表
        this.$store.dispatch("article/handleGetArticleCategoryAndType"),
      ]);
      await this.$nextTick();
    },
    async connectAIDialogue() {
      await this.$nextTick();
      const dom = this.$refs.dialogueIframe;
      const connection = await connectToChild({
        iframe: dom,
        methods: {
          searchFun: () => {
            return this.aIDialogueSearch || "";
          },
        },
      });
      const child = await connection.promise;
      this.aIDialogueIframe = child;
    },
    load() {
      this.isAIDialogueIframeLoad = true;
    },
  },
  computed: {
    ...mapGetters(["cacheViewArr"]),
    cacheNameArr() {
      return this.cacheViewArr.map((item) => item.name);
    },
    appClass() {
      // 以下页面不设置风格样式
      const sizeMode = this.sizeMode || "";
      let sizeModeClass = "";
      switch (sizeMode) {
        case "default":
          sizeModeClass = "size-mode-big";
          break;
        case "small":
          sizeModeClass = "size-mode-small";
          break;
        case "medium":
          sizeModeClass = "size-mode-middle";
          break;
        default:
          sizeModeClass = "size-mode-middle";
          break;
      }
      return sizeModeClass;
    },
    keepList() {
      return this.$store.getters.keepList || [];
    },
    reload() {
      return this.$store.getters.reload;
    },
    sizeMode() {
      return this.$store.getters.size;
    },
    routeName() {
      return this.$route.name;
    },
  },
};
</script>
<style lang="scss">
@import "assets/css/reset";

#microApp {
  width: 100%;
  height: 100%;
}

#log_center_microApp {
  flex: 1;
  display: flex;
  flex-direction: column;
  // background: #f5f6fa;
  // background-color: rgba(240, 244, 251);
  height: 100%;
}

//隐藏AG-GRID水印
.ag-watermark {
  display: none !important;
}

/* ag-gird 拖拽时,小方块hover下css穿透 */
.ag-theme-balham.ag-dnd-ghost {
  pointer-events: none;
}

html.mobile {
  // background-color: rgb(240, 244, 251);
  #microApp {
    &::before {
      content: "";
      width: 100%;
      //height: 500rem;
      position: absolute;
      z-index: -1;
      height: 798.51rem;
      //background: linear-gradient(
      //  0deg,
      //  rgba(220, 236, 252, 0) 0%,
      //  #3679dc 100%
      //);
      // background: linear-gradient(
      //   0deg,
      //   rgba(220, 236, 252, 0) 0%,
      //   rgba(117, 165, 219, 0.8) 100%
      // );
      background: linear-gradient(
        180deg,
        rgba(168, 208, 255, 0.6) 0%,
        rgba(240, 244, 251) 15%,
        rgba(240, 244, 251) 100%
      );
    }
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      bottom: 0;
      z-index: -1;
      height: 274rem;
      background-image: url("./assets/image/micro_app_bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
<style lang="scss" scoped>
.icon-back {
  width: 22rem !important;
  height: 32rem !important;
}

// 绝对定位固定关闭按钮在右上角
.right-top-btn {
  width: 58.84rem;
  height: 58.84rem;
  cursor: pointer;
  top: 20.5rem;
  right: 25rem;
  position: absolute;
  z-index: 99;
}
.head-box {
  padding: 35rem 39rem 35rem 39rem;
  position: relative;
  .left {
    width: 58.84rem;
    height: 58.84rem;
  }
  .right {
    width: 58.84rem;
    height: 58.84rem;
    cursor: pointer;
  }
  .img {
    width: 63.04rem;
    height: 63.04rem;
  }
  .text {
    // margin-left: 10.51rem;
    // margin-top: 10.51rem;

    font-size: 36rem;
    color: #3b4c75;
    //color: #ffffff;
    //line-height: 51rem;
    text-align: right;
    font-style: normal;
  }
}
</style>
